(() => {
  const instances = new WeakMap();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');

  function setup(section) {
    if (section.dataset.ingredientsReady === 'true') return;
    const track = section.querySelector('[data-ingredients-track]');
    const progress = section.querySelector('[data-ingredients-progress]');
    if (!track) return;
    section.dataset.ingredientsReady = 'true';

    function updateProgress() {
      if (!progress) return;
      const width = track.scrollWidth;
      const viewport = track.clientWidth;
      const visible = Math.min(1, viewport / width);
      const position = width > viewport ? track.scrollLeft / (width - viewport) : 0;
      progress.style.width = `${visible * 100}%`;
      progress.style.transform = `translateX(${position * (1 - visible) / visible * 100}%)`;
    }

    function onWheel(event) {
      if (event.ctrlKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0 || (event.deltaY < 0 && track.scrollLeft <= 0) || (event.deltaY > 0 && track.scrollLeft >= max - 1)) return;
      event.preventDefault();
      track.scrollLeft += event.deltaY;
    }

    let startX = 0;
    let startScroll = 0;
    let dragging = false;
    let suppressClick = false;
    function onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragging = true;
      suppressClick = false;
    }
    function onPointerMove(event) {
      if (!dragging) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) < 5 && !suppressClick) return;
      suppressClick = true;
      track.classList.add('is-dragging');
      track.scrollLeft = startScroll - distance;
    }
    function onPointerUp() {
      dragging = false;
      track.classList.remove('is-dragging');
    }
    function onClick(event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }
    function pauseVideos() {
      section.querySelectorAll('video').forEach(video => {
        if (motion.matches) video.pause();
        else if (video.paused) video.play().catch(() => {});
      });
    }

    const observer = new ResizeObserver(updateProgress);
    observer.observe(track);
    track.addEventListener('scroll', updateProgress, { passive: true });
    track.addEventListener('wheel', onWheel, { passive: false });
    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    track.addEventListener('click', onClick, true);
    motion.addEventListener('change', pauseVideos);
    pauseVideos();
    updateProgress();
    instances.set(section, () => {
      observer.disconnect();
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      motion.removeEventListener('change', pauseVideos);
      delete section.dataset.ingredientsReady;
    });
  }

  document.querySelectorAll('[data-ingredients-rail]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ingredients-rail]').forEach(setup));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ingredients-rail]').forEach(section => {
    instances.get(section)?.();
    instances.delete(section);
  }));
})();
